export const ENGAGEMENT_STATUSES = {
  DRAFT: 'Draft',
  IN_PROGRESS: 'In progress',
  PROCESSING_RESULTS: 'Processing results',
  RAW_DATA_AVAILABLE: 'Raw data available',
  INSIGHTS_AVAILABLE: 'Insights available',
  ADMIN_ONLY: 'Admin only',
} as const;

export type EngagementStatusValues =
  (typeof ENGAGEMENT_STATUSES)[keyof typeof ENGAGEMENT_STATUSES];
